export { InputArea } from './InputArea';
export type { InputAreaProps } from './InputArea';
export { InputAreaInput } from './InputAreaInput';
export type { InputAreaInputProps } from './InputAreaInput';
